/**
 * LE PERSONNEL RÉEL, et ce qu'on en retire.
 *
 * ── Ce que fait cette fonction ─────────────────────────────────────────────
 *
 * Les écrans qui montrent le PERSONNEL — organigramme, pilotes de processus,
 * habilitations — travaillent sur `gedUsers`, qui porte aussi les CONFRÈRES
 * externes. Ceux-ci sont des correspondants, pas de l'effectif : les compter
 * parmi le personnel gonfle chaque total et les propose dans des sélecteurs où
 * ils n'ont rien à faire.
 *
 * ⚠️ Écrite ICI et pas dans chaque écran : la règle est la même partout, et une
 * exclusion recopiée cinq fois finit par manquer au sixième écran — celui qu'on
 * ajoutera dans six mois.
 *
 * ── Ce qui a disparu de ce fichier (01/09/2026) ────────────────────────────
 *
 * Il excluait aussi sept comptes « recette.… », posés pour éprouver les droits
 * d'un profil par emprunt d'identité. La bascule de profil et ses comptes ont
 * été RETIRÉS : l'exclusion n'a plus d'objet, et la garder aurait laissé croire
 * qu'un jeu de comptes de test vit encore quelque part.
 */

/** La liste des VRAIES personnes : sans les comptes Correspondant (externes),
 *  qui sont des tiers du carnet, pas de l'effectif. « Confrère » est l'ancien
 *  libellé (jusqu'au 16/10/2026), encore porté par des lignes déjà en base. */
export function personnelReel<T extends { id?: string; fonction?: string }>(users: T[]): T[] {
  return (users || []).filter((u) => u.fonction !== 'Correspondant' && u.fonction !== 'Confrère');
}
